var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedBlockRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FFD4EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33201 13.7643C8.47344 13.9057 8.67778 14 8.88216 14C9.08654 14 9.29078 13.9214 9.43232 13.7643L15.8449 7.35171C16.1592 7.03739 16.1592 6.55016 15.8449 6.23574C15.5306 5.92142 15.0434 5.92142 14.7289 6.23574L8.88216 12.0825L6.35171 9.56782C6.03739 9.25351 5.55016 9.25351 5.23574 9.56782C4.92142 9.88213 4.92142 10.3694 5.23574 10.6838L8.33201 13.7643Z",
    fill: "#ED79BF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedBlockRound);
export default __webpack_public_path__ + "static/media/selected-block-round.45ed4fed80bb89d92135a54c47badb89.svg";
export { ForwardRef as ReactComponent };